import React from 'react';
import { hydrate } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import _get from 'lodash/get';

import {
    GraphQLClient,
    ApolloLib,
} from 'bdvp-graphql';
import { MEDIA_CONFIG_CONTEXT } from 'bdvp-common/src/utils/constants';

import App from 'containers/App';
import { ConfigProvider } from 'bdvp-common/src/contexts/config';

const { ApolloProvider } = ApolloLib;

let initState = _get(window, '__VIDEO_INIT_STATE__', {});
let config = _get(window, '__VIDEO_CONFIG__', {});

if (typeof initState === 'string') {

    initState = JSON.parse(initState);

}

if (typeof config === 'string') {

    config = JSON.parse(config);

}
const appConfig = _get(config, `mediaConfig.${MEDIA_CONFIG_CONTEXT.app}`, {});
const server =  appConfig.server || 'https://fastball-gateway.mlb.com';

const client = new GraphQLClient({
    server,
    data: initState,
    isSSR: false,
}).getClient();
const basePath = _get(config, 'clientBasePath') || _get(config, 'basePath', '/');

hydrate(
    <ConfigProvider config={config}>
        <ApolloProvider client={client}>
            <BrowserRouter basename={basePath}>
                <App />
            </BrowserRouter>
        </ApolloProvider>
    </ConfigProvider>,
    document.getElementById('mlb-video-app')
);
